<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">{{ 'PROVISIONING-REPORT' | translate }}</span>
        <div class="header-buttons">
            <button class="fab-button primary" (click)="exportExcel()" [disabled]="loading || rows.length === 0"
                pTooltip="Exportar relatório para Excel" tooltipPosition="left">
                <i class="pi pi-file-excel"></i>
            </button>
        </div>
    </p-header>
    <form class="filters" [formGroup]="filterForm" (ngSubmit)="searchData()">
        <div class="filter-row">
            <div class="form-control">
                <label for="startMonth">{{ 'PROVISIONING-START-MONTH' | translate }}</label>
                <p-calendar
                    view="month"
                    dateFormat="mm/yy"
                    formControlName="startMonth"
                    name="startMonth"
                    appendTo="body"
                    [readonlyInput]="true"
                    [showIcon]="true"
                    i18n>
                </p-calendar>
            </div>
            <div class="form-control">
                <label for="endMonth">{{ 'PROVISIONING-END-MONTH' | translate }}</label>
                <p-calendar
                    view="month"
                    dateFormat="mm/yy"
                    formControlName="endMonth"
                    name="endMonth"
                    appendTo="body"
                    [readonlyInput]="true"
                    [showIcon]="true"
                    i18n>
                </p-calendar>
            </div>
            <div class="form-control">
                <label for="serviceIds">{{ 'SERVICE' | translate }}</label>
                <p-multiSelect
                    formControlName="serviceIds"
                    name="serviceIds"
                    appendTo="body"
                    [options]="serviceOptions"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    [showToggleAll]="true"
                    defaultLabel="Todos"
                    selectedItemsLabel="{0} serviços selecionados">
                </p-multiSelect>
            </div>
            <div class="form-control">
                <label for="customerIds">{{ 'CUSTOMER' | translate }}</label>
                <p-multiSelect
                    formControlName="customerIds"
                    name="customerIds"
                    appendTo="body"
                    [options]="customerOptions"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    [showToggleAll]="false"
                    defaultLabel="Todos"
                    selectedItemsLabel="{0} clientes selecionados">
                </p-multiSelect>
            </div>
            <div class="form-control">
                <label for="titleNumber">{{ 'TITLE-NUMBER' | translate }}</label>
                <input pInputText type="text" formControlName="titleNumber" name="titleNumber" maxlength="20">
            </div>
            <div class="buttons">
                <div class="form-button">
                    <button (click)="clearFilters()" class="easymarine black" type="button">{{ 'CLEAR' | translate }}</button>
                </div>
                <div class="form-button">
                    <button class="easymarine primary" type="button" (click)="searchData()" [disabled]="loading">{{ 'FIND' | translate }}</button>
                </div>
            </div>
        </div>
    </form>

    <div class="divider"></div>

    <div class="total-container" *ngIf="hasSearched">
        <div class="monthly-totals">
            <span class="total-label">{{ 'PROVISIONING-BY-MONTH' | translate }}:</span>
            <span class="month-total" *ngFor="let month of monthlyTotals">
                <span class="month-label">{{ monthLabel(month.referenceMonth) }}</span>
                <span class="month-amount">{{ month.total | dynamicCurrency : currentCurrency }}</span>
            </span>
        </div>
        <div class="total-value">
            <span class="total-label">{{ 'PROVISIONING-PERIOD-TOTAL' | translate }}:</span>
            <span class="total-amount">{{ periodTotal | dynamicCurrency : currentCurrency }}</span>
        </div>
    </div>

    <div class="table">
        <p-table
            #tt
            [value]="rows"
            [autoLayout]="true"
            [loading]="loading"
            [paginator]="true"
            [rows]="pageSize"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
            [rowsPerPageOptions]="[10, 20, 50, 100]">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ 'CUSTOMER' | translate }}</th>
                    <th>{{ 'TITLE-NUMBER' | translate }}</th>
                    <th>{{ 'SERVICE' | translate }}</th>
                    <th>{{ 'CONTRACT-START' | translate }}</th>
                    <th>{{ 'CONTRACT-END' | translate }}</th>
                    <th>{{ 'PROVISIONING-INSTALLMENT-COUNT' | translate }}</th>
                    <th>{{ 'PROVISIONING-INSTALLMENT-VALUE' | translate }}</th>
                    <th>{{ 'PROVISIONING-REFERENCE-MONTH' | translate }}</th>
                    <th>{{ 'PROVISIONING-VALUE' | translate }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>{{ item.customerName }}</td>
                    <td class="text-center">{{ item.titleNumber }}</td>
                    <td>{{ item.productName }}</td>
                    <td class="text-center">{{ dayLabel(item.contractStartDate) || '--' }}</td>
                    <td class="text-center">{{ dayLabel(item.contractEndDate) || '--' }}</td>
                    <td class="text-center">{{ item.installmentCount ?? '--' }}</td>
                    <td class="text-right">{{ item.installmentValue | dynamicCurrency : currentCurrency }}</td>
                    <td class="text-center">{{ monthLabel(item.referenceMonth) }}</td>
                    <td class="text-right">{{ item.provisionedValue | dynamicCurrency : currentCurrency }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="9" class="text-center">
                        <div class="empty-message-container">
                            <ng-container *ngIf="hasSearched; else idle">Não foram encontrados resultados</ng-container>
                            <ng-template #idle>Escolha o período (e, se quiser, serviço, cliente e título) e clique em Pesquisar.</ng-template>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-fieldset>
